import { BoxProps, ColorOptions, SpaceOptions, TextNewProps as TextProps } from '@jfs/ui-new'
import { convertHexToRGBA } from '../../../utils'

const shadow = {
  shadowColor: '#00000029',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 1,
  shadowRadius: 0,
}

const styles = (theme: any, themePadding: any) => ({
  container: {
    underlayColor: 'TRANSPARENT',
    direction: 'row',
    align: 'center',
    justify: 'space-between',
    paddingHorizontal: themePadding.HORIZONTAL_PADDING,
    borderRadius: 2,
  } as BoxProps,
  creditCardContainer: {
    direction: 'column',
  } as BoxProps,
  cardCount: {
    position: 'absolute',
    bg: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    width: '15px',
    height: '15px',
    borderRadius: '7.5px',
    justify: 'center',
    align: 'center',
    right: -5,
  } as BoxProps,
  listItemContainer: {
    underlayColor: 'TRANSPARENT',
    paddingHorizontal: themePadding.HORIZONTAL_PADDING,
    pv: 6,
  } as BoxProps,
  listButton: {
    pv: 'MEDIUM',
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  leftContainer: {
    flexDirection: 'row',
    direction: 'row',
    justify: 'space-between',
  } as BoxProps,
  error: {
    fontSize: 10,
    fontWeight: '700',
    color: theme.brandColor,
  } as TextProps,
  cardIconContainer: (isLargeScreen: boolean) =>
    ({
      borderRadius: isLargeScreen ? '8px' : '4px',
      width: isLargeScreen ? '60px' : '40px',
      height: isLargeScreen ? '40px' : '24px',
      justify: 'center',
      align: 'center',
      borderWidth: 1,
      marginTop: 4,
      borderColor: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
      ...shadow,
    } as BoxProps),
  emptyContainer: (isLargeScreen: boolean) =>
    ({
      borderRadius: '8px',
      width: isLargeScreen ? '72px' : '48px',
      height: isLargeScreen ? '48px' : '32px',
      justify: 'center',
      align: 'center',
    } as BoxProps),
  cvvFormContainer: {
    flexWrap: 'wrap',
    direction: 'row',
    align: 'center',
  } as BoxProps,
  balanceText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: theme.bodyTextColor,
  } as TextProps,
  bsContainer: {
    paddingHorizontal: '50px' as SpaceOptions,
  } as BoxProps,
  bsContainerMobile: {
    paddingHorizontal: 'LARGE',
    paddingVertical: 16,
    bg: theme?.bodyBgColor as ColorOptions,
  } as BoxProps,
  bsContainerMobileTop: {
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    paddingHorizontal: themePadding.HORIZONTAL_PADDING,
    paddingVertical: themePadding.VERTICAL_PADDING,
  } as BoxProps,
  bsContainerMobileBottom: {
    justifyContent: 'flex-end',
    paddingHorizontal: themePadding.HORIZONTAL_PADDING,
    paddingVertical: themePadding.VERTICAL_PADDING,
  } as BoxProps,
  scrollStyle: {
    flexShrink: 1,
  },
})

export { styles }
